import React from "react";
import { Form, Field, Formik } from "formik";
import Overview from "../campaigns/overview";
import LoadingScreen from "../misc/loading";
import ApiService from "../../Services/ApiService";
import AlertService from "../../Services/AlertService";

class ClientGeneral extends React.Component {

    // default state
    state = {
        data: {
            client_name: "",
            linkedin_account_id: "",
            linkedin_organization_id: "",
            account_currency: "USD",
            monthly_accounts: "",
            start_day: ""
        },
        is_loading: true,
        is_new: true,
        header: "",
        active: ''
    };

    componentDidMount() {
        if (this.props.data) {
            this.setState(this.props.data);
        }
    }

    saveClient = (values) => {
        if (this.state.is_new) {
            ApiService.post("/api/clients/create", values)
                .then(response => {
                    this.props.history.push("/clients");
                    AlertService.success('Client saved successfully');
                })
                .catch(error => {
                    AlertService.error('Oops! There was an error creating the Client');
                })
        } else {
            ApiService.post("/api/clients/update", values)
                .then(response => {
                    this.props.history.push("/clients");
                    AlertService.success('Client saved successfully');
                })
                .catch(error => {
                    AlertService.error('Oops! There was an error updating the Client');
                })
        }

    };

    render = () => {
        let form = (
            <Formik initialValues={this.state.data} onSubmit={this.saveClient} >
                {props => {
                    const {
                        values,
                        touched,
                        errors,
                        dirty,
                        isSubmitting,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        handleReset
                    } = props;
                    return (
                        <form className="form-container" onSubmit={handleSubmit}>
                            <div className="overview">
                                <div className="form-col">
                                    <div className="input-group">
                                        <label htmlFor="client_name" style={{ display: "block" }}>
                                            Client Name
                                        </label>
                                        <input
                                            id="client_name"
                                            placeholder="Enter the clients name"
                                            type="text"
                                            value={values.client_name}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            className={
                                                errors.client_name && touched.client_name
                                                    ? "text-input error"
                                                    : "text-input"
                                            }
                                        />
                                        {errors.client_name && touched.client_name && (
                                            <div className="input-feedback">{errors.client_name}</div>
                                        )}
                                    </div>

                                    <div className="input-group">
                                        <label htmlFor="linkedin_account_id" style={{ display: "block" }}>
                                            LinkedIn Account ID
                                        </label>
                                        <input
                                            id="linkedin_account_id"
                                            placeholder="Enter the clients LinkedIn Account ID"
                                            type="text"
                                            value={values.linkedin_account_id}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            className={
                                                errors.linkedin_account_id && touched.linkedin_account_id
                                                    ? "text-input error"
                                                    : "text-input"
                                            }
                                        />
                                        {errors.linkedin_account_id && touched.linkedin_account_id && (
                                            <div className="input-feedback">{errors.linkedin_account_id}</div>
                                        )}
                                    </div>

                                    <div className="input-group">
                                        <label htmlFor="linkedin_organization_id" style={{ display: "block" }}>
                                            LinkedIn Organization ID
                                        </label>
                                        <input
                                            id="linkedin_organization_id"
                                            placeholder="Enter the clients LinkedIn Organization ID"
                                            type="text"
                                            value={values.linkedin_organization_id}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            className={
                                                errors.linkedin_organization_id && touched.linkedin_organization_id
                                                    ? "text-input error"
                                                    : "text-input"
                                            }
                                        />
                                        {errors.linkedin_organization_id && touched.linkedin_organization_id && (
                                            <div className="input-feedback">{errors.linkedin_organization_id}</div>
                                        )}
                                    </div>

                                    <div className="input-group">
                                        <label htmlFor="account_currency" style={{ display: "block" }}>
                                            Account Currency
                                        </label>
                                        <input
                                            id="account_currency"
                                            type="text"
                                            value={values.account_currency}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            className={
                                                errors.account_currency && touched.account_currency
                                                    ? "text-input error"
                                                    : "text-input"
                                            }
                                        />
                                        {errors.account_currency && touched.account_currency && (
                                            <div className="input-feedback">{errors.account_currency}</div>
                                        )}
                                    </div>

                                    <div className="input-group">
                                        <label htmlFor="monthly_accounts" style={{ display: "block" }}>
                                            Monthly Accounts
                                        </label>
                                        <input
                                            id="monthly_accounts"
                                            type="text"
                                            value={values.monthly_accounts}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            className={
                                                errors.monthly_accounts && touched.monthly_accounts
                                                    ? "text-input error"
                                                    : "text-input"
                                            }
                                        />
                                        {errors.monthly_accounts && touched.monthly_accounts && (
                                            <div className="input-feedback">{errors.monthly_accounts}</div>
                                        )}
                                    </div>

                                    <div className="input-group">
                                        <label htmlFor="start_day" style={{ display: "block" }}>
                                            Start Day
                                        </label>
                                        <input
                                            id="start_day"
                                            placeholder="1"
                                            type="number" min="1" max="31"
                                            value={values.start_day}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            className={
                                                errors.start_day && touched.start_day
                                                ? "text-input error"
                                                : "text-input"
                                            }
                                        />
                                        {errors.start_day && touched.start_day && (
                                        <div className="input-feedback">{errors.start_day}</div>
                                        )}
                                    </div>

                                    <button type="button" className="outline" onClick={() => { this.props.history.push("/clients") }} >
                                        Cancel
                                    </button>
                                    <button type="submit" disabled={isSubmitting}>
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </form>
                    );
                }}
            </Formik>
        )

        if (!this.state.is_loading) {
            if (this.props.data) {
                return (
                    <div className="page-main">
                        {form}
                    </div>
                )
            } else {
                return (
                    <div className="page-main">
                        <div className="page-content">
                            {form}
                        </div>
                    </div>
                )
            }
        } else {

            return <LoadingScreen />;

        }

    }

}

export default ClientGeneral